module.exports = __webpack_public_path__ + "static/media/PIBKG_blue.10467540.png";